import React from "react";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  return (
    <footer className="footer py-40">
      <div className="container container-lg">
        <div className="footer-item-two-wrapper d-flex align-items-start flex-wrap">
          <div className="footer-item max-w-275"></div>
          <div className="footer-item">
            <h6 className="footer-item__title">About us</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Career option
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/contact"
                  className="text-gray-600 hover-text-main-600"
                >
                  Contact Us
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  About Us
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Corporate Info
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Track order
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Help</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Payments
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/contact"
                  className="text-gray-600 hover-text-main-600"
                >
                  Shipping
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Affiliate
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/#" className="text-gray-600 hover-text-main-600">
                  Product support
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/frequentlyAskedQuestion"
                  className="text-gray-600 hover-text-main-600"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Policy</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/termsAndCondition"
                  className="text-gray-600 hover-text-main-600"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/privacyPolicy"
                  className="text-gray-600 hover-text-main-600"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/cancellationPolicy"
                  className="text-gray-600 hover-text-main-600"
                >
                  Cancellation Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/returnPolicy"
                  className="text-gray-600 hover-text-main-600"
                >
                  Return Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/accountDeletion"
                  className="text-gray-600 hover-text-main-600"
                >
                  Account Deletion Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-item">
            <h6 className="footer-item__title">Registered office</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <div className="flex-align gap-16 mb-16">
                  <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                    <i className="ph-fill ph-phone-call" />
                  </span>
                  <span className="text-md text-gray-900 hover-text-main-600">
                    <a
                      href="tel:+917418655526"
                      className="text-gray-600 hover-text-main-600"
                    >
                      +91 741-86-555-26
                    </a>
                  </span>
                </div>
              </li>
              <li className="mb-16">
                <div className="flex-align gap-16 mb-16">
                  <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                    <i className="ph-fill ph-envelope" />
                  </span>
                  <span className="text-md text-gray-900 hover-text-main-600">
                    <a
                      href="mailto:info@powergroups.in"
                      className="text-gray-600 hover-text-main-600"
                    >
                      info@powergroups.in
                    </a>
                  </span>
                </div>
              </li>
              <li className="mb-16">
                <div className="flex-align gap-16 mb-16">
                  <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                    <i className="ph-fill ph-map-pin" />
                  </span>
                  <span className="text-gray-600 main-600">
                    POWER TRADING COMPANY (PTC)
                    <br />
                    No: 6/485A, TIME SQUARE,
                    <br />
                    PUDUKOTTAI MAIN ROAD, GUNDUR,
                    <br />
                    TRICHY-620007.
                    <br />
                    LANDMARK: MIET COLLEGE.
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <div className="footer-item">
            <h6 className="footer-item__title">Shop on The Go</h6>
            <p className="mb-16">PTC App is available. Get it now</p>
            <div className="flex-align gap-8 my-32">
              <Link to="https://play.google.com/store/apps/details?id=com.powertradingcompany&pcampaignid=web_share" target="blank" className="">
                <img src="../assets/images/thumbs/store-img2.png" alt="" />
              </Link>
            </div>
            <ul className="flex-align gap-16">
              <li>
                <Link
                  to="https://www.facebook.com/powertradingcompany.ptc/"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-facebook-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instagram.com/powergroups.in/"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-instagram-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="https://x.com/powergroups_"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-twitter-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.youtube.com/@powergroups_in"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-youtube-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.linkedin.com/company/power-groups"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-linkedin-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="https://pin.it/JcfJ3kU0w"
                  className="w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8 hover-bg-main-two-600 hover-text-white"
                  target="blank"
                >
                  <i className="ph-fill ph-pinterest-logo" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
